import { z } from "zod";
import { optionalSearch } from "./shared";

export const declareDissentSearchSchema = z.object({
  runId: optionalSearch(z.string().min(1)),
});

export type DeclareDissentSearch = z.infer<typeof declareDissentSearchSchema>;
